import { z } from 'zod';

export const ListWithdrawal = z.object({
	id: z.number(),
	status: z.enum([
		'PENDING',
		'IN_REVIEW',
		'REVIEW_DENIED',
		'WITHDRAWN',
		// Old statuses, to be removed at some point
		'SUCCESS',
		'FAILED',
		'ABORTED',
	]),
	amount: z.string(),
	createdAt: z.date(),
});

export type ListWithdrawal = z.infer<typeof ListWithdrawal>;
